import { UsersState } from "./users-state.interface";

export function createUsersState(): UsersState {
  return {
    allUsers: [],
    count: 0,
    loading: false,
    next: null,
    previous: null,
    searchResults: [],
  };
}
